module.exports = __webpack_public_path__ + "static/media/48393535_2308764202532091_3487547829860171776_o.9cb4860b.jpg";